module.exports = __webpack_public_path__ + "static/media/documentpayslip.cc0497fc.svg";